import React from 'react';
import classes from './CheckingInfoBox.module.css';

const CheckingInfoBox = (props) => {
  const data = props.data;

  // Convert data object to an array of [key, value] pairs
  const entries = Object.entries(data);

  // Function to extract the letter inside the parentheses
  const getLetterFromKey = (key) => {
    const regex = /\((\w)[;:)]/;
    const match = key.match(regex);
    return match ? match[1] : null;
  };

  // Define the desired order of the letters
  const order = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

  // Sort the entries based on the extracted letters
  entries.sort((a, b) => {
    const letterA = getLetterFromKey(a[0]);
    const letterB = getLetterFromKey(b[0]);

    const indexA = order.indexOf(letterA);
    const indexB = order.indexOf(letterB);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    } else if (indexA !== -1) {
      return -1;
    } else if (indexB !== -1) {
      return 1;
    } else {
      return 0;
    }
  });

  return (
    <div>
      {entries.map(([key, value]) => (
        <div key={key} className={classes.box}>
          <p>{key}:</p>
          <p>{value}</p>
        </div>
      ))}
    </div>
  );
};

export default CheckingInfoBox;
